import React from "react";

import { Dropdown, mergeStyleSets } from "@fluentui/react";
import { useTheme } from "styled-components";
import StatusSquare from "./StatusSquare";

type VehiclePolicyStatusOption = {
  label: string;
  value: number;
  color: string;
};

type Props = {
  value: VehiclePolicyStatusOption | null;
  onChange?: (value: VehiclePolicyStatusOption | null) => void;
  options: any[];
  isClearable?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  isOptionDisabled?: (o: VehiclePolicyStatusOption) => boolean;
  styles?: Partial<any>;
  portalTarget?: any;
};

export const VehiclePolicyStatusSelect = ({
  value,
  onChange,
  options,
  isClearable,
  isLoading,
  isDisabled,
  isOptionDisabled,
  styles,
  portalTarget,
}: Props) => {
  const theme = useTheme();

  const onRenderOption = (option: any): JSX.Element => {
    const classes = getClassNames(false);
    return (
      <div className={classes.itemWrap}>
        {option.color && (
          <div className={classes.item}>
            <StatusSquare color={option.color} />
          </div>
        )}
        {option.text}
      </div>
    );
  };

  const onRenderTitle = (options: any): JSX.Element => {
    const option = options[0];
    const classes = getClassNames(false);

    return (
      <div className={classes.itemWrap}>
        {option.color && (
          <div className={classes.item}>
            <StatusSquare color={option.color} />
          </div>
        )}
        {option.text}
      </div>
    );
  };

  const optionsForFluentDropdown = options.map((item) => {
    return {
      ...item,
      text: item.label,
      key: item.value,
    };
  });
  return (
    <>
      <Dropdown
        style={{
          minWidth: "210px",
        }}
        styles={{
          root: {
            "& .ms-Dropdown-title": {
              borderColor: theme.palette.neutralTertiaryAlt,
            },
          },
        }}
        defaultSelectedKey={value?.value}
        onChange={(_, option) => {
          onChange && onChange(option as any);
        }}
        onRenderOption={onRenderOption}
        onRenderTitle={onRenderTitle}
        placeholder={""}
        label=""
        options={optionsForFluentDropdown}
        disabled={isDisabled}
      />
    </>
  );
};

const getClassNames = (isPending: boolean) =>
  mergeStyleSets({
    itemWrap: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
    },
    item: {
      border: `1px dashed ${isPending ? "black" : "transparent"}`,
      borderRadius: "16px",
      width: "16px",
      height: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
  });
